export default __webpack_public_path__ + "static/media/480_business01-fr-mobile.782f039d.png";